module.exports = __webpack_public_path__ + "img/open_in_browser.741e1194.png";